import React, {Component} from 'react';
import PropTypes from "prop-types"
import {_Object} from "react-utils-y";
import {connect} from 'react-redux'
import {Theme} from 'theme-y';
// import {Theme} from '../../../theme/index';

import {setFormData, delFormData} from '../../actions/index'
import {selectSty} from './selectStyle';
import {formTypeDom, verifyFn} from './subpage';
import {renderBox, setLocationFn} from '../publicField';

const propTypes = {
    designationTheme: PropTypes.string,
    formType: PropTypes.string,
    inputName: PropTypes.string.isRequired,
    formText: PropTypes.string,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    hintText: PropTypes.string,
    textWidth: PropTypes.string,
    valueWidth: PropTypes.string,
    changeValue: PropTypes.func,
    errorText: PropTypes.string,
    dataType: PropTypes.string,
    // remarks  无规则 自定义传参
    // regex:PropTypes.number,//正则 input特有
    regexText: PropTypes.string,//input特有
};

class SelectCheckboxField extends Theme {
    constructor(props) {
        super(props);
        let _state = {
            focusState: false,//处理点击的样式
            initFocusState: 0,//是否触发过 0 未触发  1 已经触发
            errorState: false,//是否显示报错提示框，  true  显示报错  false  不显示

            showSelect: false,//是否显示下拉值
            moveSelect: "",

            shouldUpdateChoose: true,//选择展示区滚动条
            shouldUpdateList: true,//列表滚动条true

        };
        this.state = _Object.merge(this.state || {}, _state)
    };

    //列表滚动条
    initScrollList = () => {
        this.setState({shouldUpdateList: false});
    };
    //选择展示区滚动条
    initScrollChoose = () => {
        this.setState({shouldUpdateChoose: false});
    };

    //显示下拉选项
    showSelectFn = (e) => {
        this.setState({

            showSelect: true,
            focusState: true,
            shouldUpdateChoose: true,
            shouldUpdateList: true,
        });
        setLocationFn(this, e)
    };

    //关闭下拉选项
    closeSelect = ()=> {
        this.setState({
            showSelect: false,
            focusState: false,
            initFocusState: 1,
        });
    };

    //移动select
    moveSelect = (item) => {
        this.setState({
            moveSelect: item.text,
        });
    };

    //移除select
    leaveSelect = () => {
        this.setState({
            moveSelect: "",
        });
    };

    //选中下拉值
    handleSelect = (item) => {
        let props = this.props;
        if (props.disabled || !props.inputName)return false;

        this.setState({
            //showSelect: false,
            focusState: false,
            shouldUpdateChoose: true,
        });

        let selectCheckbox = props.formData.default[props.inputName];
        let [texts,values,objs] = [selectCheckbox.text || [], selectCheckbox.value || [], selectCheckbox.obj || []];

        let index = values.indexOf(item.value);
        if (index >= 0) {
            texts.splice(index, 1);
            values.splice(index, 1);
            objs.splice(index, 1);
        } else {
            texts.push(item.text);
            values.push(item.value);
            objs.push(item);
        }

        let obj = [{
            type: "selectCheckbox",//type 类型
            name: props.inputName,//name input名称
            text: texts,//text input值
            value: values,
            obj: objs,
            remarks: props.remarks,//备注
            other: {
                required: props.required
            }
        }];

        props.setFormData(obj, props.dataType);
        props.changeValue && props.changeValue(obj[0]);
    };

    //删除选中的值
    delChooseItem = (item) => {

    };

    componentWillMount() {
        let props = this.props;
        let flag = "set";
        try {
            //已经存在数据 就不 重新赋值
            flag = props.formData[props.dataType || "default"][props.inputName] ? "none" : "set"
        } catch (ex) {
            flag = "set"
        } finally {
            if (props.inputName && flag == "set") {
                let obj = [{
                    type: "selectCheckbox",//type 类型
                    name: this.props.inputName,//name input名称
                    text: [],//text input值
                    value: [],
                    obj: [],
                    remarks: this.props.remarks,//备注
                    other: {
                        required: this.props.required
                    }
                }];
                props.setFormData(obj, props.dataType);
            }
        }

    }

    componentDidMount() {

    }
    componentWillUnmount() {
        this.props.delFormData(this.props.inputName || "", this.props.dataType)
    }
    render() {
        return renderBox(this, selectSty, formTypeDom, verifyFn)
    }
}

SelectCheckboxField.propTypes = propTypes;

const mapStateToProps = state => {
    return {
        formData: state.formData,
        subVerifyRes: state.subVerifyRes,
        theme: state.theme,
    }
};

const mapDispatchToProps = dispatch => ({
    setFormData: (data, dataType) => dispatch(setFormData(data, dataType)),
    delFormData: (inputName, dataType) => dispatch(delFormData(inputName, dataType))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectCheckboxField)

